<style>
.edi-mobilecheck {
	height: 100%;
	background-color: #eee;
}
.edi-mobilecheck .fieldset-1 {
	/*margin-top: 4em !important;*/
}
.edi-mobilecheck .mobile {
	text-align: center;
	line-height: 2.5em;
}
.edi-mobilecheck .mobile b {
	font-weight: normal;
	font-size: 1.5em;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
.edi-mobilecheck .bind {
	display: block;
	color: rgba(38, 159, 165, 0.63);
	text-align: center;
	font-size: 1.3em;
	margin-top: 1.5em;
}
.edi-mobilecheck .notfound {
	text-align: center;
}
.edi-mobilecheck .notfound:before {
	content: ' ';
	background: url('../assets/email/notfound.png') no-repeat 0 0;
	display: inline-block;
	width: 30px;
	height: 30PX;
	background-size: 30px;
	vertical-align: bottom;
	margin-right: 0.3em;
}
</style>

<template>
	<div>
		<form v-if="mobile === ''" class="ui-content edi-mobilecheck" @submit.prevent="onMobileSubmit">
			<p class="notfound fieldset-1">抱歉，您尚未绑定手机号码！</p>
			<fieldset class="ui-controlgroup">
				<input type="button" value="确定" class="submit" @click="onConfirm"/>
			</fieldset>
			<router-link to="/mobile-bind" class="bind">立即绑定手机</router-link>
		</form>
		<form v-else class="ui-content edi-mobilecheck" @submit.prevent="onMobileSubmit">
			<p class="mobile fieldset-1" style="margin-top: 0 !important">
				当前绑定手机号码<br/>
				<b>{{hideMobile}}</b><br>
				如需解绑，请先验证
			</p>
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-one-item" style="display: flex;border-bottom: 1px solid #ddd">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-one-item">
					<div class="ui-col-6"><input type="text" placeholder="验证码" v-model="code"/></div
						><div class="ui-col-4 ui-align-right"><mobile-code :type="7" :mobile="mobile" :uuid="verifyUUID" :verifyCode="verifyCode"></mobile-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="确定" class="submit" :class="{ 'ui-disable': submitDisable }"/>
			</fieldset>
		</form>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>

<script>
import MobileCode from '../components/MobileCode'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'

export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 2,
			tipsFont: '',
			mobile: this.$route.query.mobile,
			hasEmail: false,
			code: '',
			hideMobile: '',
			codePatrn: /^\d{4}$/,
			sec: 1500,
			bool: '',
			verifyUUID: this.$fxUtils.createUUID(),
			verifyCode: ''
		}
	},
	created () {
		this.hideMobile = this.mobile.substr(0, 3) + '******' + this.mobile.substr(-3, 3)
	},
	computed: {
		submitDisable () {
			return !this.code
		},
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	components: {
		'mobile-code': MobileCode,
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
			this.bool = msg[1]
			this.unbind(this.bool)
		},
		onConfirm () {
			this.$router.back()
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		onMobileSubmit () {
			// 对接解绑手机接口
			if (this.submitDisable) return
			if (this.code === '') {
				this.autoTips('验证码不能为空')
				return false
			} else if (!(this.codePatrn.test(this.code))) {
				this.autoTips('验证码为四位数字')
				return false
			}
			if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.tips = true
			this.tipsFont = '解绑手机后将无法用手机号码登录，是否继续？'
		},
		unbind (bool) {
			if (bool) {
				this.$http.post('/cldEdi/business/unbindUserTelephone', {vCode: this.code, mobile: this.mobile}).then((response) => {
					if (response.body.result) {
						this.autoTips('解绑手机成功')
						this.delaySkip('/accounts')
					} else {
						this.autoTips(response.body.message)
					}
				})
			} else {
				return false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// Mobile.vue?1d6ebd04